import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useApiUrl } from '../hooks/useApiUrl'

export const Logout = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const apiUrl = useApiUrl()

  useEffect(() => {
    const exec = async () => {
      await auth.signOut()

      const searchParams = new URLSearchParams(window.location.search)
      const isDCP = apiUrl.isDcp
      if (isDCP || searchParams.get('mode') === 'autoClose') {
        window.close()
        return
      }

      // ログアウト後にリダイレクトさせる
      navigate('/login')
    }

    exec()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}
